import * as React from "react";
import { FlexContainer } from "../grid/flexcontainer";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const dialogFooterClass = css({
    borderTop: `1px solid ${getThemeColorVar("border", "default")}`,
    backgroundColor: getThemeColorVar("background", "default"),
});
export const DialogFooter = (props) => {
    return (React.createElement("div", { className: cx(dialogFooterClass) },
        React.createElement(FlexContainer, Object.assign({}, props), props.children)));
};
export default DialogFooter;
//# sourceMappingURL=dialogfooter.js.map